jQuery(function ($) {

  $('[data-table]').each(function () {

    const $table = $(this);
    const $rows  = $table.find('tbody tr');
    const perPage = parseInt($table.data('per-page'), 10);

    let activeRows = $rows.toArray();
    let currentPage = 1;

    function render() {
      $rows.hide();

      const start = (currentPage - 1) * perPage;
      const end   = start + perPage;

      $(activeRows.slice(start, end)).show();

      $(document).trigger('pagination:update', [
        Math.ceil(activeRows.length / perPage)
      ]);
    }

    render();

    /* =============================
       PAGINATION SYNC
    ============================== */
    $(document).on('pagination:change', function (e, page) {
      currentPage = page;
      render();
    });

    /* =============================
       FILTERS COMPONENT SYNC
    ============================== */
    $(document).on('filters:apply', function (e, query) {

      activeRows = $rows.filter(function () {
        return $(this).text().toLowerCase().includes(query.toLowerCase());
      }).toArray();

      currentPage = 1;
      render();
    });

    /* =============================
       PRESETS COMPONENT SYNC
    ============================== */
    $(document).on('presets:change', function (e, visibleCols) {

      $table.find('tr').each(function () {
        $(this).children().each(function (i) {
          $(this).toggle(visibleCols.includes(i));
        });
      });

    });

    /* =============================
       SORTING
    ============================== */
    if ($table.data('sort')) {
      $table.find('th[data-sort]').on('click', function () {
        const i = $(this).data('sort');

        activeRows.sort((a, b) =>
          $(a).children().eq(i).text()
            .localeCompare($(b).children().eq(i).text(), undefined, { numeric: true })
        );

        currentPage = 1;
        render();
      });
    }

  });

});
